import requestProvider from "./axiosHandler";

const getBrandByMatchedEmployee = (employeeId) => {

    return requestProvider
        .get(`brand-manager/get-by-employee/${employeeId}`)
}

const createBrandRepresentative = (list) => {

    return requestProvider
        .post('/brand-manager', list)
}

const deleteRepresentative = (id) => {

    return requestProvider
        .delete(`/brand-manager/${id}`)
}


export {getBrandByMatchedEmployee, createBrandRepresentative, deleteRepresentative}